<template>
  <div>
    <div class="content-i">
      <div class="content-box pb-0">
        <div class="element-wrapper pb-0">
          <h6 class="element-header">
            Posting Free Text
          </h6>
          <div class="element-box">
            <div class="element-info my-0">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-mail">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        Posting Free Text
                      </h5>
                      <div class="element-inner-desc"> To see 'Posting free text' settings, please, select the client </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-sm-3 col-md-4">
                  <i id="textToggle" v-b-toggle.search class="text-primary os-icon os-icon-arrow-up float-right showhand"></i>
                </div>
              </div>
            </div>
            <b-collapse id="search" ref="searchForm" v-model="visibleSearchBox">
              <form v-on:submit.prevent="loadClientPostingFreeText">
                <div class="row">
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="client" class="d-block text-center">Client</label>
                        <b-form-select v-model="textRequest.client" :options="clients" value-field="short_name" text-field="postroom_label" @change="onClientChange">
                          <template #first>
                            <b-form-select-option :value="undefined" disabled> Select the client </b-form-select-option>
                          </template>
                          <b-form-select-option value="other"> Other </b-form-select-option>
                        </b-form-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-from" class="d-block text-center"> Date from </label>
                          <datePicker id="date-from" v-model="textRequest.date_from" class="form-control text-center" :config="datePickerFromConfig" placeholder="Date from"></datePicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 pt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="date-to" class="d-block text-center"> Date to </label>
                        <datePicker id="date-to" v-model="textRequest.date_to" class="form-control text-center" :config="datePickerToConfig" placeholder="Date to"></datePicker>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row justify-content-between pt-3">
                  <div class="col-lg-2">
                    <b-input-group class="col-lg-12">
                      <b-input-group-prepend>
                        <label class="input-group-text"> Per page </label>
                      </b-input-group-prepend>
                      <b-form-select v-model="perPage" :options="pageOptions" @change="loadClientPostingFreeText"></b-form-select>
                    </b-input-group>
                  </div>
                  <div class="col-lg-4 text-right mt-3">
                    <button v-if="!loading" class="btn btn-primary" type="submit" > Search </button>
                    <b-button v-else variant="primary" disabled>
                      <b-spinner small type="grow"></b-spinner>
                      Search
                    </b-button>
                  </div>
                </div>
              </form>
            </b-collapse>
          </div>
        </div>
        <div class="element-wrapper mt-0 pb-0 pt-0">
          <ResponseInfo v-if="getResponseInfo.responseName == 'clientPostingFreeTextView'" />
        </div>
      </div>
    </div>
    <div class="content-i" v-if="textRequest.client && items && showTable">
      <div class="content-box pt-0">
        <div class="element-wrapper">
          <div class="element-box">
            <div class="element-box-tp">
              <div class="controls-below-table row">
                <div class="col-sm-12 col-lg-4 col-md-12 table-records-info">
                  <p> {{totalRows}} entries found </p>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-8">
                  <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="posting-free-text-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-lg-2 col-md-4">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text"> Per page </label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
              <b-table id="posting-free-text-table" responsive striped hover bordered :fields="fields" :busy.sync="loading" :items="items" :currentPage="currentPage" :total-rows="totalRows" :show-empty="true">
                <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="items">
                  <vcl-table :rows="5" :columns="fields.length"></vcl-table>
                </template>
                <template v-slot:cell(entry_date)="data">
                  <span> {{data.item.entry_date | clientDateFormatter(datePickerFormat)}} </span>
                </template>

                <template v-slot:cell(postroom_label)="data">
                  <span> {{clientName}} </span>
                </template>

                <template v-slot:cell(doc_type)="data">
                  <span v-if="data.item.doc_name"> {{data.item.doc_name}} </span>
                  <span v-else> - </span>
                </template>

                <template v-slot:cell(reference)="data">
                  <span v-if="data.item.reference"> {{data.item.reference}} </span>
                  <span v-else> - </span>
                </template>

                <template v-slot:cell(pages)="data">
                  <template v-if="data.item.is_invoiced">
                    <span> {{data.item.pages}} </span>
                  </template>
                  <template v-else>
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0" step="1" v-model="data.item.pages" class="form-control" />
                    </div>
                  </template>
                </template>

                <template v-slot:cell(total_docs)="data">
                  <template v-if="data.item.is_invoiced">
                    <span> {{data.item.total_docs}} </span>
                  </template>
                  <template v-else>
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0" step="1" v-model="data.item.total_docs" class="form-control" />
                    </div>
                  </template>
                </template>

                <template v-slot:cell(total_charge)="data">
                  <template v-if="data.item.is_invoiced">
                    <span> {{data.item.total_charge}} </span>
                  </template>
                  <template v-else>
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0.00" step="0.01" v-model="data.item.total_charge" class="form-control" />
                    </div>
                  </template>
                </template>

                <template v-slot:cell(actions)="data">
                  <div v-if="!data.item.is_invoiced" class="btn btn-sm btn-primary" @click="updateClientPostingFreeText(data.item)"> Update </div>
                  <div v-if="userLevel >= 2.00" class="btn btn-sm btn-danger" @click="openDeleteModal(data.item.id, $event.target)"> Delete </div>
                </template>

                <template slot="bottom-row">
                  <td>
                    <span> {{clientName}} </span>
                  </td>
                  <td>
                     <span> {{today}} </span>
                  </td>
                  <td>
                    <b-form-select v-model="newItem.doc_type" :options="clientDocTypes" value-field="id" text-field="name" >
                      <template #first>
                        <b-form-select-option value="0"> Other </b-form-select-option>
                      </template>
                    </b-form-select>
                  </td>
                  <td>
                    <div class="input-group input-group-sm">
                      <b-form-input type="text" v-model="newItem.reference" class="form-control" />
                    </div>
                  </td>
                  <td>
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0" step="1" v-model="newItem.pages" class="form-control" />
                    </div>
                  </td>
                  <td>
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0" step="1" v-model="newItem.total_docs" class="form-control" />
                    </div>
                  </td>
                  <td>
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0.00" step="0.01" v-model="newItem.total_charge" class="form-control" />
                    </div>
                  </td>
                  <td>
                    <div class="btn btn-success" @click="addClientPostingFreeText"> Add </div>
                  </td>
                </template>
              </b-table>
              <div class="controls-below-table row mt-4">
                <div class="col-sm-12 col-lg-4 col-md-12 table-records-info">
                  <p> {{totalRows}} entries found </p>
                </div>
                <div class="col-sm-12 col-lg-6 col-md-8">
                  <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage" aria-controls="posting-free-text-table">
                  </b-pagination>
                </div>
                <div class="col-sm-12 col-lg-2 col-md-4">
                  <b-input-group class="form-group col-lg-12">
                    <b-input-group-prepend>
                      <label class="input-group-text"> Per page </label>
                    </b-input-group-prepend>
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-input-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ModalDeleteItem :modal="deleteModal" @hide="resetDeleteModal" @deleteItem="deleteClientPostingFreeText"/>
    <div v-if="overlayBackgroundDisplay" class="modal-backdrop show"></div>
  </div>
</template>

<script>
import {VclTable} from 'vue-content-loading'
import ResponseInfo from '@/components/ResponseInfo.vue'
import {mapGetters} from "vuex"
import moment from "moment"
import datePicker from 'vue-bootstrap-datetimepicker'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
import ModalDeleteItem from "@/components/Helper_Components/ModalDeleteItem.vue"

export default {
  name: 'PostingFreeText',
  components: {
    ModalDeleteItem,
    VclTable,
    ResponseInfo,
    datePicker,
  },
  data() {
    return {
      showTable: true,
      textRequest: {
        date_from: this.$route.query.date_from,
        date_to: this.$route.query.date_to,
        client: this.$route.query.client ? this.$route.query.client : undefined,
      },
      newItem: {
        client: null,
        doc_type: '0',
        ref: '',
        pages: 0,
        total_docs: 0,
        total_charge: '0.00'
      },
      visibleSearchBox: true,
      datePickerFromConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        showClear: true
      },
      datePickerToConfig: {
        icons: {
          time: 'os-icon os-icon-calendar-time',
          date: 'os-icon os-icon-basic-2-259-calendar',
          up: 'os-icon os-icon-chevron-up',
          down: 'os-icon os-icon-chevron-down',
          previous: 'os-icon os-icon-chevron-left',
          next: 'os-icon os-icon-chevron-right',
          clear: 'os-icon os-icon-trash',
          close: 'os-icon os-icon-cancel-circle'
        },
        minDate: moment(new Date('1979-01-01'), this.datePickerFormat),
        showClear: true
      },
      fields: [
        {key: 'postroom_label', label: 'Client', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'entry_date', label: 'Date', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'doc_type', label: 'Document Type', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'reference', label: 'Document Reference', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'pages', label: 'Pages', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'total_docs', label: 'Docs', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'total_charge', label: 'Stamp', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'actions', label: 'actions', sortable: false, thClass: 'hover-pointer brand-color'},
      ],
      currentPage: this.$route.query.page ? this.$route.query.page : 1,
      perPage: this.$route.query.per_page ? this.$route.query.per_page : 20,
      pageOptions: [10, 20, 50, 100],
      loading: false,
      overlayBackgroundDisplay: false,
      deleteModal: {
        itemId: null,
        title: 'Delete selected posting free text',
        id: 'deletePostingFreeTextModal',
        question: 'Delete selected posting free text - are you sure?'
      },
    }
  },
  watch: {
    dateFrom(date) {
      if (date) {
        this.datePickerToConfig.minDate = moment(date, this.datePickerFormat)
      } else {
        this.datePickerToConfig.minDate = moment(new Date('1979-01-01'), this.datePickerFormat)
      }
    },
    perPage(newCount, oldCount) {
      if (newCount != oldCount) {
        this.loadClientPostingFreeText()
      }
    },
    currentPage(newCount, oldCount) {
      if (newCount != oldCount) {
        this.loadClientPostingFreeText()
      }
    },
  },
  methods: {
    addClientPostingFreeText() {
      this.newItem.client = this.textRequest.client
      this.$store.dispatch('addClientPostingFreeText', {
        item: this.newItem
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadClientPostingFreeText()
        }
      })
    },
    updateClientPostingFreeText(item) {
      this.$store.dispatch('updateClientPostingFreeText', {
        item: item
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadClientPostingFreeText()
        }
      })
    },
    deleteClientPostingFreeText(done) {
      this.$store.dispatch('deleteClientPostingFreeText', {
        itemId: this.deleteModal.itemId,
        userLevel: this.userLevel
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadClientPostingFreeText()
        }
        this.resetDeleteModal()
      }).finally(() => {
        done();
      })
    },
    onClientChange() {
      this.currentPage = 1
      this.perPage = 20
      this.loadClientPostingFreeText();
    },
    loadClients() {
      this.$store.dispatch('loadClientsByEnv')
    },
    loadClientPostingFreeText() {
      this.resetNewItem()
      this.loading = true

      Object.keys(this.textRequest).forEach((key) => (this.textRequest[key] === '' || this.textRequest[key] === null)  && (this.textRequest[key] = undefined))
      this.$router.push({ query: { ...this.$route.query, ...this.textRequest, page: this.currentPage, per_page: this.perPage } })

      this.$store.dispatch('loadClientPostingFreeText', {
        client: this.textRequest.client,
        date_from: this.textRequest.date_from,
        date_to: this.textRequest.date_to,
        page: this.currentPage,
        per_page: this.perPage,
      }).finally(() => {
        this.loading = false
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.showTable = true
        } else {
          this.showTable = false
        }
      })
    },
    openDeleteModal(postingFreeTextId, button) {
      this.deleteModal.itemId = postingFreeTextId
      this.overlayBackgroundDisplay = true
      this.$root.$emit('bv::show::modal', this.deleteModal.id, button)
    },
    resetDeleteModal() {
      this.$root.$emit('bv::hide::modal', this.deleteModal.id)
      this.overlayBackgroundDisplay = false
      this.deleteModal.itemId = null
    },
    resetNewItem() {
      this.newItem = {
        client: null,
        doc_type: '0',
        reference: '',
        pages: 0,
        total_docs: 0,
        total_charge: '0.00'
      }
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
    clients: {
      get() {
        return this.$store.getters.getClientsByEnv
      }
    },
    datePickerFormat() {
      if (this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
        return this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, '/')
      } else {
        return 'DD-MM-YYYY'
      }
    },
    clientPostingFreeText: {
      get() {
        return this.$store.getters.getClientPostingFreeText
      }
    },
    items: {
      get() {
        if (this.clientPostingFreeText && this.clientPostingFreeText.data) {
          return this.clientPostingFreeText.data
        }

        return null
      }
    },
    totalRows: {
      get() {
        if (this.clientPostingFreeText && this.clientPostingFreeText.total) {
          return this.clientPostingFreeText.total
        }

        return 0
      }
    },
    clientDocTypes: {
      get() {
        return this.$store.getters.getClientDocTypes
      }
    },
    today: {
      get() {
        return moment(new Date()).format(this.datePickerFormat)
      }
    },
    clientName: {
      get() {
        if (Array.isArray(this.clients) && this.textRequest.client !== '' && this.textRequest.client !== null) {
          let client = this.clients.find(o => o.short_name === this.textRequest.client)

          if (client !== undefined) {
            return client.postroom_label
          }
        }

        return 'Other'
      }
    },
    userLevel: {
      get() {
        return this.$store.getters.getUserLevel
      }
    },
    dateFrom() {
      return this.textRequest.date_from
    },
  },
  created() {
    this.loadClients()

    this.datePickerFromConfig.format = this.datePickerFormat
    this.datePickerToConfig.format = this.datePickerFormat
    this.$store.dispatch('alertClearResponse')

    if (Object.keys(this.$route.query).length) {
      this.textRequest = Object.assign({}, this.$route.query)

      if (this.$route.query.page) {
        this.currentPage = parseInt(this.$route.query.page)
      }
      if (this.$route.query.per_page) {
        this.perPage = parseInt(this.$route.query.per_page)
      }

      this.loadClientPostingFreeText()
    }
  },
  filters: {
    clientDateFormatter: function(date, datePickerFormat) {
        return moment.unix(date).format(datePickerFormat)
    },
  },
}

</script>

<style scoped>

.table-responsive >>> tbody, .table-responsive >>> thead {
  text-align: center;
}

.table-responsive >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

.table-responsive >>> .hover-pointer:hover {
  cursor: pointer !important;
}

#textToggle{
  font-size: 1.2rem;
  font-weight: bold;
  display:inline-block;
  -moz-transition: all .5s linear;
  -webkit-transition: all .5s linear;
  transition: all .5s linear;
}

#textToggle.collapsed{
  -moz-transform:rotate(180deg);
  -webkit-transform:rotate(180deg);
  transform:rotate(180deg);
}

</style>
